<div class="p-8 min-h-screen bg-white m-4 rounded-xl border border-gray-100 shadow-sm">
  @if (loading) {
    <div class="flex items-center justify-center py-24">
      <div class="text-center">
        <div class="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-primary mb-3"></div>
        <p class="text-gray-600 text-sm">Loading…</p>
      </div>
    </div>
  } @else if (error) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-2">
      <i class="fas fa-exclamation-circle text-red-600"></i>
      <p class="text-red-800">{{ error }}</p>
      <button type="button" (click)="load()" class="ml-auto text-sm text-red-700 underline">Retry</button>
    </div>
  } @else {
    <div class="mb-8">
      <h1 class="text-2xl font-bold text-gray-900 mb-1">Driver dashboard</h1>
      <p class="text-sm text-gray-600">Your assigned jobs and notifications at a glance.</p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
        <h3 class="text-sm font-medium text-gray-600 mb-2">Active assignments</h3>
        <p class="text-3xl font-bold text-gray-900">{{ activeCount }}</p>
        <p class="text-xs text-gray-500 mt-1">Not completed or cancelled</p>
      </div>
      <div class="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
        <h3 class="text-sm font-medium text-gray-600 mb-2">Completed (all time)</h3>
        <p class="text-3xl font-bold text-gray-900">{{ completedCount }}</p>
      </div>
    </div>

    <a
      routerLink="/driver/jobs"
      class="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:opacity-90 transition-opacity"
    >
      <i class="fas fa-tasks"></i>
      View my jobs
    </a>
  }
</div>
